import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css'
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const Main = props => (
    <Router>
        <Route path = "/" component = {App}/> 
    </Router>
)

ReactDOM.render(<Main/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js